import React from "react";
import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom"; // Added useHistory
import swal from "sweetalert";
import config from "../config.js";

// Cache for parsed cookies
let cachedCookies = null;

const parseCookies = () => {
  if (cachedCookies) return cachedCookies;

  const cookieObj = {};
  document.cookie.split(";").forEach((cookie) => {
    const [key, value] = cookie.trim().split("=");
    if (key) cookieObj[key] = value || true;
  });

  cachedCookies = cookieObj;
  return cookieObj;
};

const middleware = (navigate) => {
  const requiredCookies = [
    "urreport",
    "urdashboard",
    "urrole",
    "uruserGroup",
    "urview",
    "uralarm",
    "uruserDashboard",
    "uruser",
    "userToken",
    "ursource",
    "userID",
  ];

  const cookies = parseCookies();
  const missingCookies = requiredCookies.some((cookie) => !(cookie in cookies));

  if (missingCookies) {
    document.cookie.split(";").forEach((cookie) => {
      const key = cookie.trim().split("=")[0];
      if (key) {
        document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
      }
    });
    cachedCookies = null;

    swal({
      title: "Invalid Session",
      text: "Your session has expired. Please login again.",
      icon: "warning",
      timer: 2000,
      buttons: false,
    }).then(() => {
      // history.replace("/"); // Changed to history.replace
      navigate("/", { replace: true });
    });

    return false;
  }

  return true;
};

// const ProtectedRoute = ({ component: Component, ...restOfProps }) => {
//   const navigate = useNavigate();

//   return (
//     <Route
//       {...restOfProps}
//       render={({ location, match }) => {
//         const canProceed = middleware(navigate);
//         return canProceed ? <Component /> : null;
//       }}
//     />
//   );
// };

const ProtectedRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const canProceed = middleware(navigate); // Perform your auth logic here

  if (!canProceed) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <Outlet />; // Renders the nested route component
};
export default ProtectedRoute;
